import { createQuery } from 'QueryKit'
import { getAnnotationsFiltered } from 'API/definitions/iris/annotation'

const useImageAnnotationsFiltered = createQuery<any, any, Error>({
  primaryKey: 'image-annotations-filtered',
  queryFn: ({ queryKey: [primaryKey, variables] }) => {
    return getAnnotationsFiltered(variables?.filterQueryParams)
  },
})

export { useImageAnnotationsFiltered }
